import { getProductCustomisation } from 'src/client/js/store/selectors/product';
import useProductKey from './use-product-key';
import { useSelector, useDispatch } from 'react-redux';

export default (productId) => {
  const dispatch = useDispatch();
  const productKey = useProductKey(productId);
  const productCustomisation = useSelector(
    state => getProductCustomisation(state)
  );
  const updateProductCustomisation = customisation => (
    dispatch(updateProductCustomisation(productKey, customisation))
  );
  const removeProductCustomisation = keys => (
    dispatch(removeProductCustomisation(keys))
  );
  return {
    productCustomisation,
    updateProductCustomisation,
    removeProductCustomisation,
  };
};
